(function () {
    'use strict';

    /**
     * Testimonials section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_Testimonials.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "testimonialsSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionTestimonials', sectionTestimonials);

    function sectionTestimonials() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionTestimonialsCtrl,
            controllerAs: 'testimonialsSection'
        };
    }

    SectionTestimonialsCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionTestimonialsCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];
        // owl carousel options, read by the owl-carousel directive when it starts
        vm.options = {
            items: 1,
            autoplay: true,
            loop: true,
            autoplayTimeout: 3000,
            touchDrag: true,
            mouseDrag: true,
            autoplayHoverPause: false
        };

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the testimonials of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetTestimonials(eventId, lang).then(function (response) {
                vm.items = response.data;
                // drag only when there is more than one testimonial
                vm.options = {
                    items: 1,
                    autoplay: true,
                    loop: true,
                    autoplayTimeout: 3000,
                    touchDrag: vm.items.length > 1,
                    mouseDrag: vm.items.length > 1,
                    autoplayHoverPause: false
                };
            });
        }
    }
})();
